import { render } from "./ListInfo.vue?vue&type=template&id=1c202b55&scoped=true"
import script from "./ListInfo.vue?vue&type=script&lang=js"
export * from "./ListInfo.vue?vue&type=script&lang=js"

import "./ListInfo.vue?vue&type=style&index=0&id=1c202b55&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c202b55"

export default script